<script setup lang="ts">
  import { CardItem, Widget } from "@src/components";

  const { item_id } = defineProps<{ item_id: string }>();
  const emit = defineEmits<{ (e: "close"): void }>();
</script>

<template>
  <Widget data-testid="card-item-widget">
    <CardItem :itemId="item_id" @close="emit('close')" @back="emit('close')" />
  </Widget>
</template>
